<template>
  <div class="ttshop_user">
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <div class="ttshop_useright">
          <div class="ttshop_coupon min_h">
            <div class="flexsb">
              <div class="fap_title"
                   v-if="this.myInvoice==1|| this.myInvoice==2">发票信息</div>
              <div class="add_fap"
                   @click="addinvoice(1)"
                   v-if="(this.myInvoice==1&& this.addbut)|| this.myInvoice==2 ">新增发票抬头</div>
            </div>
            <div class="invoice-one"
                 v-if="this.myInvoice==1 ">
              <div class="invoiceFrom">
                <el-form :model="invoice"
                         :rules="rules"
                         ref="invoice"
                         size="mini"
                         label-width="100px"
                         class="demo-ruleForm"
                         label-position="top">
                  <el-form-item label="发票类型"
                                prop="type">
                    <el-radio-group v-model="invoice.type"
                                    @change="showRadio">
                      <el-radio :label=1>个人</el-radio>
                      <el-radio :label=2>企业</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="发票类型:"
                                prop="invoice_type">
                    <el-select placeholder="请选择发票类型"
                               @change="other"
                               v-model="invoice.invoice_type">
                      <el-option v-for="item in invoice_addlist"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value+''">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="发票抬头:"
                                prop="header">
                    <el-input size="small"
                              v-model="invoice.header"
                              placeholder="请输入发票抬头"></el-input>
                  </el-form-item>
                  <div v-if="this.geren==1 ||  this.invoice.type==2">
                    <el-form-item label="纳税人识别码:"
                                  prop="taxpayer">
                      <el-input size="small"
                                v-model="invoice.taxpayer"
                                placeholder="请输入纳税人识别码"></el-input>
                    </el-form-item>
                    <div v-if="otherInfo==2||  this.invoice.invoice_type==2">
                      <el-form-item label="开户行:"
                                    prop="bank_name">
                        <el-input size="small"
                                  v-model="invoice.bank_name"
                                  placeholder="请输入开户行"></el-input>
                      </el-form-item>
                      <el-form-item label="银行账号:"
                                    prop="bank_account">
                        <el-input size="small"
                                  v-model="invoice.bank_account"
                                  placeholder="请输入银行账号"></el-input>
                      </el-form-item>
                      <el-form-item label="注册地址:"
                                    prop="register_address">
                        <el-input size="small"
                                  v-model="invoice.register_address"
                                  placeholder="请输入注册地址"></el-input>
                      </el-form-item>
                      <el-form-item label="注册电话:"
                                    prop="register_tel">
                        <el-input size="small"
                                  v-model="invoice.register_tel"
                                  placeholder="请输入注册电话"></el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <el-form-item>
                    <div class="flex">
                      <div class="sub"
                           @click="saveInvoice('invoice')">保存发票信息</div>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <!-- 发票列表 -->
            <div v-else-if="this.myInvoice==2">
              <div class="invoive_main">
                <el-card v-for="(item,index) in this.infoList "
                         :key='index'
                         class="m21">
                  <div class="box-card">
                    <div class="qitext"
                         v-if="item.type==1">个</div>
                    <div class="qitext"
                         v-else>企</div>
                    <div style="width:100%">
                      <div class="flex">
                        <div class="invoice_gsname"
                             @click="seeDetals(item)">{{item.header}}</div>
                      </div>
                      <div class="dutyparagraph m20 flexs">
                        <div @click="seeDetals(item)"
                             style="cursor:pointer">发票类型:{{item.invoice_type=="1"?"增值税普通发票" :"增值税专用发票"}}</div>
                        <div class="flex">
                          <div class="f12"
                               @click="getInvoice(item)">编辑</div>
                          <div class="f12"
                               @click="delInvoice(item)">删除</div>
                        </div>
                      </div>

                    </div>
                  </div>
                </el-card>
              </div>
            </div>
            <!-- 发票明细 -->
            <div v-else-if="this.myInvoice==3">
              <InvioceInfo :Invoiceinfomation="this.Invoiceinfomation"></InvioceInfo>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
import InvioceInfo from './InvoiceInfo'
import '../invoiceInformation/invoiceInformation.css'
export default {
  components: {
    InvioceInfo
  },
  data() {
    return {
      addbut: true,
      infoList: [],
      Invoiceinfomation: {},
      geren: 1, //类型为1的时候，geren为2
      myInvoice: 4,
      invoice: {
        type: '',
        invoice_type: '',
        header: '',
        taxpayer: '',
        bank_name: '',
        bank_account: '',
        register_address: '',
        register_tel: ''
      },
      otherInfo: '', //显示隐藏专票信息
      invoice_addlist: [],
      rules: {
        type: [
          { required: true, message: '请选择发票类型', trigger: 'change' }
        ],
        invoice_type: [
          { required: true, message: '请选择发票类型', trigger: 'change' }
        ],
        header: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        taxpayer: [
          { required: true, message: '请输入纳税人识别码', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bank_account: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        register_address: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        register_tel: [
          { required: true, message: '请输入注册电话', trigger: 'blur' }
        ]
      },
      id: '' //删除id
    }
  },
  created() {
    this.invoiceList()
  },
  mounted() {},
  methods: {
    // 初次回显发票列表
    invoiceList() {
      this.$api
        .qycgInvoice({
          type: '',
          shop_type: 'qycg'
        })
        .then(res => {
          if (res.code == 0) {
            if (res.data.list) {
              this.infoList = res.data.list
              this.infoList.forEach((item, index) => {
                this.id = item.id
              })
              this.myInvoice = 2
            } else {
              this.myInvoice = 1
            }
            // console.log(res)
          }
        })
    },
    // 保存发票信息
    saveInvoice(formName) {
      if (this.name == 1) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$api
              .queryInvoice({
                shop_type: 'qycg',
                // access_token: this.$store.state.qycg_user.access_token,
                invoice_type: this.invoice.invoice_type,
                type: this.invoice.type,
                header: this.invoice.header,
                taxpayer: this.invoice.taxpayer,
                bank_account: this.invoice.bank_account,
                bank_name: this.invoice.bank_name,
                register_address: this.invoice.register_address,
                register_tel: this.invoice.register_tel
              })
              .then(res => {
                // console.log(res)
                if (res.code == 0) {
                  this.$message({
                    showClose: true,
                    message: '添加成功',
                    type: 'success',
                    offset: 200,
                    duration: 1000
                  })
                } else {
                  this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'warning',
                    offset: 200,
                    duration: 1000
                  })
                }
              })
              .catch(err => {
                // console.log(err);
              })
          }
        })
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$api
              .queryInvoice({
                shop_type: 'qycg',
                // access_token: this.$store.state.qycg_user.access_token,
                invoice_type: this.invoice.invoice_type,
                id: this.editId,
                type: this.invoice.type,
                header: this.invoice.header,
                taxpayer: this.invoice.taxpayer,
                bank_account: this.invoice.bank_account,
                bank_name: this.invoice.bank_name,
                register_address: this.invoice.register_address,
                register_tel: this.invoice.register_tel
              })
              .then(res => {
                // console.log(res)
                if (res.code == 0) {
                  this.$message({
                    showClose: true,
                    message: '添加成功',
                    type: 'success',
                    offset: 200,
                    duration: 1000
                  })
                } else {
                  this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'warning',
                    offset: 200,
                    duration: 1000
                  })
                }
              })
              .catch(err => {
                // console.log(err);
              })
          }
        })
      }
    },
    // 显示隐藏不同发票填写的内容
    other(val) {
      if (val == 1) {
        this.otherInfo = 1
      } else {
        this.otherInfo = 2
      }
      // console.log(val)
    },
    addinvoice(i) {
      if (i == 1) {
        this.name = 1
        this.myInvoice = 1
      }
    },
    showRadio(i) {
      // this.invoice = {}
      this.invoice = {
        type: i
      }
      if (i == 1) {
        this.geren = 2 //类型为1(个人)的时候，geren为2
        this.invoice_addlist = [
          {
            value: 1,
            label: '增值税普通发票'
          }
        ]
      } else {
        this.invoice_addlist = [
          {
            value: 1,
            label: '增值税普通发票'
          },
          {
            value: 2,
            label: '增值税专用发票'
          }
        ]
        this.geren = 1 //类型为1(个人)的时候，geren为1
      }
    },
    //发票列表明细
    seeDetals(i) {
      this.Invoiceinfomation = i
      this.addbut = false
      this.myInvoice = 3
    },
    //删除
    delInvoice(i) {
      let data = {
        shop_type: 'qycg',
        id: i.id
      }
      this.$confirm('确定是否要删除次发票?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.DelInvoice(data).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.invoiceList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //返回
    fanhui() {
      this.myInvoice = 2
    },
    // 编辑----初次回显发票信息
    getInvoice(e) {
      this.name = 2
      this.editId = e.id
      this.$api
        .qycginvoiceDetails({ shop_type: 'qycg', id: this.editId })
        .then(res => {
          if (res.code == 0) {
            this.showRadio(res.data.invoice_type)
            this.other(res.data.invoice_type)
            this.invoice = res.data
            this.invoice.invoice_type = res.data.invoice_type + ''
            this.addbut = false
            this.myInvoice = 1
          } else {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          }
          // console.log(res)
        })
    },
    //详情-----编辑
    detailsEditing(i) {
      this.name = 2
      this.editId = i.id
      this.$api
        .qycginvoiceDetails({ shop_type: 'qycg', id: this.editId })
        .then(res => {
          if (res.code == 0) {
            this.showRadio(res.data.invoice_type)
            this.other(res.data.invoice_type)
            this.invoice = res.data
            this.invoice.invoice_type = res.data.invoice_type + ''
            this.addbut = false
            this.myInvoice = 1
          } else {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          }
          // console.log(res)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.ttshop_coupon {
  background-color: #ffffff;
  width: 100%;
  // padding-top: 20px;
  padding: 24px 20px;
  .flexsb {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .fap_title {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333;
      margin: 5px 0px 5px 10px;
    }
    .add_fap {
      width: 114px;
      height: 30px;
      background: #ff0e25;
      border-radius: 2px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      text-align: center;
      line-height: 30px;
      margin: 5px 10px 5px 0;
    }
  }
  .invoice-one {
    // width: 1080px;
    height: 763px;
    margin: 0 auto;
    background: #ffffff;
    // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    .invoiceFrom {
      width: 100%;
      // padding: 24px 20px 24px 450px;
      box-sizing: border-box;
      margin: 0 auto;

      .flex {
        display: flex;
      }
      .sub {
        cursor: pointer;
        width: 114px;
        height: 32px;
        background: #ff0e25;
        border-radius: 2px;
        color: #fff;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
      }
    }
  }
}
.invoive_main {
  .box-card {
    display: flex;
  }
  .m21 {
    margin-top: 20px;
    .qitext {
      cursor: pointer;
      width: 18px;
      height: 18px;
      background: #fff0f1;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff3259;
      text-align: center;
      line-height: 18px;
      margin-right: 4px;
    }
    .flex {
      display: flex;
      align-items: center;
      .invoice_gsname {
        cursor: pointer;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333;
      }
    }
    .m20 {
      margin-top: 20px;
    }
    .dutyparagraph {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666;
    }
    .flexs {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .f12 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0e9cff;
      margin-left: 24px;
    }
  }
}
</style>